// Module
var code = `<div class="alert">
  <strong>NOTE</strong>: This operation is accepted only when no product operations were already executed for all affected branches.
</div>

<div class="alert" ng-if="\$ctrl.noRunningBankHolidays">
  <strong>INFO</strong>: Currently there are no bank running holidays.
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="form">
  <table class="table">
    <tbody>
      <tr>
        <td>Holiday:</td>
        <td>
          <select
            ng-model="\$ctrl.holiday"
            ng-options="holiday as holiday.name for holiday in \$ctrl.holidays | orderBy:'date'"
            ng-change="\$ctrl.onHolidayChange()"
            required>
          </select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.holiday">
        <td>Name:</td>
        <td>
          <input type="text"
                 value="{{\$ctrl.holiday.name}}"
                 disabled="disabled">
        </td>
      </tr>
      <tr ng-if="\$ctrl.holiday">
        <td>Date:</td>
        <td>
          <date
            output-format="date"
            ng-model="\$ctrl.holiday.date"
            disabled="disabled"></date>
        </td>
      </tr>
      <tr ng-if="\$ctrl.holiday">
        <td>Affected branches:</td>
        <td>
          <div ng-repeat="branch in \$ctrl.affectedBranches">{{branch.name}}</div>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/delete-running-bank-holiday/delete-running-bank-holiday.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;